import { AppContext, DispatchContext } from "../AppContext";
import Service from "../services/service";


// Provide string format string.format
if (!String.prototype.format) {
  String.prototype.format = function () {
    var args = arguments;
    let result = this.replace(/{(\d+)}/g, (match, number) => {
      return typeof args[number] != 'undefined' ? args[number] : "-";
    });
    result = result.replace(/{(\d+:[a-z]*:[a-z]*)}/g, (match, phrase) => {
      let colonIdx = phrase.lastIndexOf(':');
      let number = phrase.substring(0, 1);
      let extensionS = phrase.substring(2, colonIdx);
      let extensionP = phrase.substring(colonIdx + 1);
      return typeof args[number] != 'undefined' && args[number] == 1 ? extensionS : extensionP;
    });
    return result;
  };
}



export function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + ";path=/;domain=.plagaware.com";
}

export function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

export function pad(num, size) {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}

export function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  decimalCount = Math.abs(decimalCount);
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

  const negativeSign = amount < 0 ? "-" : "";

  let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
  let j = (i.length > 3) ? i.length % 3 : 0;

  return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
};

export function timeConverter(unix_ts, dateOnly, format = "{1}/{2} {0} {3}:{4}") {
  var a;
  if (dateOnly && dateOnly === 'time') {
    a = new Date(unix_ts);
  } else {
    a = new Date(unix_ts * 1000);
  }
  var year = a.getFullYear();
  var month = a.getMonth() + 1; // 0 = Jan
  var day = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time = format.format(year, pad(month, 2), pad(day, 2), pad(hour, 2), pad(min, 2), pad(sec, 2));

  return time;
}



export function redirectExternal(url) {
  window.location.href = url;
  return null;
}

export function navigateToBackendUrl(url) {
  window.location.href = config.backendUrl + url;
  return null;
}


export function getModuloColor(id) {
  return config.colors[id % 10];
}


export function getHashedDirectory(prefix, id) {
  const floor100 = (Math.floor(id / 100.0) * 100.0);
  const ceil100 = (Math.ceil((id + 1) / 100.0) * 100.0);
  const floor10000 = (Math.floor(id / 10000.0) * 10000.0);
  const ceil10000 = (Math.ceil((id + 1) / 10000.0) * 10000.0);
  const folder = prefix + "/" + floor10000 + "-" + ceil10000 + "/" + floor100 + "-" + ceil100;
  return folder;
}

export function buildHashedFilename(prefix, id, filename) {
  const fileName = getHashedDirectory(prefix, id) + "/" + filename;
  return fileName;
}

export function getParaLevelString(paraLevel, messages) {
  let paraLevelString = (paraLevel < 60) ? resolveNotificationMessage("paraphraseLevel.heavy", messages) :
    (paraLevel <= 80) ? resolveNotificationMessage("paraphraseLevel.moderately", messages) :
      (paraLevel <= 95) ? resolveNotificationMessage("paraphraseLevel.slightly", messages) : resolveNotificationMessage("paraphraseLevel.copy", messages);
  return resolveNotificationMessage("paraphraseLevel.string", messages).format(paraLevelString, paraLevel);
}

//console.log(process.env);
export const config = {
  backendUrl: (process.env.NODE_ENV === 'production') ? process.env.REACT_APP_BACKEND_URL_PROD : process.env.REACT_APP_BACKEND_URL,
  frontendUrl: (process.env.NODE_ENV === 'production') ? process.env.REACT_APP_FRONTEND_URL_PROD : process.env.REACT_APP_FRONTEND_URL,
  mode: (process.env.NODE_ENV === 'production') ? 'PROD' : 'DEV',
  sessionCookieName: 'PlagAwareSession',
  ssoDomainCookieName: 'SSODomain',
  colors: [
    'rgba(239, 179, 196, 0.99)',
    'rgba(255, 191, 178, 0.99)',
    'rgba(255, 207, 159, 0.99)',
    'rgba(255, 227, 133, 0.99)',
    'rgba(216, 235, 177, 0.99)',
    'rgba(188, 233, 207, 0.99)',
    'rgba(168, 232, 228, 0.99)',
    'rgba(200, 221, 229, 0.99)',
    'rgba(209, 209, 220, 0.99)',
    'rgba(229, 197, 209, 0.99)'
  ],
  backColors: [
    'rgba(239, 179, 196, 0.5)',
    'rgba(255, 191, 178, 0.5)',
    'rgba(255, 207, 159, 0.5)',
    'rgba(255, 227, 133, 0.5)',
    'rgba(216, 235, 177, 0.5)',
    'rgba(188, 233, 207, 0.5)',
    'rgba(168, 232, 228, 0.5)',
    'rgba(200, 221, 229, 0.5)',
    'rgba(209, 209, 220, 0.5)',
    'rgba(229, 197, 209, 0.5)'
  ],

  maxNumberFileUpload: 100,
  maxNumberFileUploadForm: 1,
  textAllowed: 1000000,
  truncateChars: 100,            // Characters to show around markup
  captchaKey: '6LdrsyYaAAAAAD23otfmHmNxCncnKkHbSr76DJDB',
  captchaUrl: 'https://www.google.com/recaptcha/api.js?render=6LdrsyYaAAAAAD23otfmHmNxCncnKkHbSr76DJDB'
}
/*
export function getColorForPercentage(value, min = 0, max = 100) 
{
  // Define the colors as RGB components
  const red = { r: 255, g: 0, b: 0 };  // Pure red
  const green = { r: 0, g: 255, b: 0 }; // Pure green
  const white = { r: 255, g: 255, b: 255 }; // White as intermediate

  // Clamp value to the defined range
  if (value <= min) return rgbToHex(colors[min].r, colors[min].g, colors[min].b);
  if (value >= max) return rgbToHex(colors[max].r, colors[max].g, colors[max].b);

  // Normalize value to [0, 1] range for interpolation
  const normalizedValue = (value - min) / (max - min);

  // Interpolate between red -> white -> green
  let r, g, b;
  if (normalizedValue < 0.5) {
      // Interpolate between red and white (first half)
      const ratio = normalizedValue / 0.5;
      r = Math.round(colors[min].r + (colors[mid].r - colors[min].r) * ratio);
      g = Math.round(colors[min].g + (colors[mid].g - colors[min].g) * ratio);
      b = Math.round(colors[min].b + (colors[mid].b - colors[min].b) * ratio);
  } else {
      // Interpolate between white and green (second half)
      const ratio = (normalizedValue - 0.5) / 0.5;
      r = Math.round(colors[mid].r + (colors[max].r - colors[mid].r) * ratio);
      g = Math.round(colors[mid].g + (colors[max].g - colors[mid].g) * ratio);
      b = Math.round(colors[mid].b + (colors[max].b - colors[mid].b) * ratio);
  }
  
  // Convert the result to a hex color code
  return rgbToHex(r, g, b);
}
*/
export function blendColors(value, colors = [{ r: 255, g: 0, b: 0 }, { r: 255, g: 255, b: 255 }, { r: 0, g: 255, b: 0 }], values = [0, 50, 100]) 
//export function blendColors(value, colors, values) 
{

  const min = 0, mid = 1, max = 2;

  // Define the colors as RGB components
  const red = { r: 255, g: 0, b: 0 };  // Pure red
  const green = { r: 0, g: 255, b: 0 }; // Pure green
  const white = { r: 255, g: 255, b: 255 }; // White as intermediate

  // Clamp value to the defined range
  if (value <= values[min]) return rgbToHex(colors[min].r, colors[min].g, colors[min].b);
  if (value >= values[max]) return rgbToHex(colors[max].r, colors[max].g, colors[max].b);

  // Normalize value to [0, 1] range for interpolation
  const normalizedValue = (value - values[min]) / (values[max] - values[min]);
  const normalizedMidValue = (values[mid] - values[min]) / (values[max] - values[min]);

  // Interpolate between red -> white -> green
  let r, g, b;
  if (normalizedValue < normalizedMidValue) {
      // Interpolate between red and white (first half)
      const ratio = normalizedValue / normalizedMidValue;
      r = Math.round(colors[min].r + (colors[mid].r - colors[min].r) * ratio);
      g = Math.round(colors[min].g + (colors[mid].g - colors[min].g) * ratio);
      b = Math.round(colors[min].b + (colors[mid].b - colors[min].b) * ratio);
  } else {
      // Interpolate between white and green (second half)
      const ratio = (normalizedValue - (normalizedMidValue)) / (1 - normalizedMidValue);
      r = Math.round(colors[mid].r + (colors[max].r - colors[mid].r) * ratio);
      g = Math.round(colors[mid].g + (colors[max].g - colors[mid].g) * ratio);
      b = Math.round(colors[mid].b + (colors[max].b - colors[mid].b) * ratio);
  }
  
  // Convert the result to a hex color code
  return rgbToHex(r, g, b);
}


function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1).toUpperCase();
}
/*
export function getColorForPercentage(pct, greenValue = 0, redValue = 100, alpha = 1) {
  let r, g, b;

  // Ensure alpha is between 0 and 1
  alpha = Math.max(0, Math.min(1, alpha));
  midValue = (greenValue + redValue / 2);

  if ((pct < midValue) && (greenValue < redValue)) {
    // Interpolate between red (255, 0, 0) and yellow (255, 255, 0)
    r = 230;
    g = Math.round(255 * (pct / 50)); // Scale green from 0 to 255
    b = Math.round(255 * (pct / 50));
  } else {
    // Interpolate between yellow (255, 255, 0) and green (0, 255, 0)
    r = Math.round(255 * (1 - (pct - 50) / 50)); // Scale red from 255 to 0
    g = 230;
    b = Math.round(255 * (1 - (pct - 50) / 50)); // Scale red from 255 to 0;
  }

  // Convert RGB to hex with alpha
  const rgbToHexWithAlpha = (r, g, b, a) =>
    "#" + [r, g, b].map(x => x.toString(16).padStart(2, '0')).join('')
    + Math.round(a * 255).toString(16).padStart(2, '0');

  return rgbToHexWithAlpha(r, g, b, alpha);
}
*/
export function createPercentageBar(width, height, colors, values, data) {
  // Create SVG namespace
  const svgNS = "http://www.w3.org/2000/svg";

  // Create the SVG element
  const svg = document.createElementNS(svgNS, "svg");
  svg.setAttribute("width", width);
  svg.setAttribute("height", height);
  svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
  
  if (!data)
    return "";


  const lastPos = data[data.length - 1][0];
  const totalRelativeWidth = lastPos['s'] + lastPos['l'];
  


  // Loop over data to create bars
  data.forEach(pair => {
    const [posData, percentage] = pair;
    const relativeStart = posData['s'];
    const relativeWidth = posData['l'];
    // Current X position for placing the next bar
    let currentX = (relativeStart / totalRelativeWidth) * width;
    // Scale the width proportionally to the total relative width
    const barWidth = (relativeWidth / totalRelativeWidth) * width;
    const barHeight = height; // Full height for each bar

    // Create a rectangle (bar)
    const rect = document.createElementNS(svgNS, "rect");
    rect.setAttribute("x", currentX);
    rect.setAttribute("y", 0);
    rect.setAttribute("width", barWidth);
    rect.setAttribute("height", barHeight);
    rect.setAttribute("fill", blendColors(percentage, colors, values));

    // Append the rectangle to the SVG element
    svg.appendChild(rect);

    // Update current X position for the next bar
    currentX += barWidth;
  });

  const yMax = height / 3;
  const rect = document.createElementNS(svgNS, "rect");
  rect.setAttribute("x", 0);
  rect.setAttribute("y", 0);
  rect.setAttribute("width", width);
  rect.setAttribute("height", yMax);
  rect.setAttribute("fill", '#FFFFFFAA');
  svg.appendChild(rect);


  const frame = document.createElementNS(svgNS, "rect");
  frame.setAttribute("x", 0);
  frame.setAttribute("y", 0);
  frame.setAttribute("width", width);
  frame.setAttribute("height", height);
  frame.setAttribute('stroke', '#999999');
  frame.setAttribute("fill", 'none');
  svg.appendChild(frame);


  // Convert the SVG element to a string and return
  const serializer = new XMLSerializer();
  return serializer.serializeToString(svg);
}

export function createPercentageBarVertical(width, height, data) {
  // Create SVG namespace
  const svgNS = "http://www.w3.org/2000/svg";

  // Create the SVG element
  const svg = document.createElementNS(svgNS, "svg");
  svg.setAttribute("width", width);
  svg.setAttribute("height", height);
  svg.setAttribute("viewBox", `0 0 ${width} ${height}`);

  const totalRelativeHeight = data.reduce((sum, pair) => sum + pair[0], 0);

  // Current Y position for placing the next bar
  let currentY = 0;

  // Loop over data to create bars
  data.forEach(pair => {
    const [relativeHeight, percentage] = pair;

    // Scale the width proportionally to the total relative width
    const barWidth = width; // Full width for each bar
    const barHeight = (relativeHeight / totalRelativeHeight) * height; 

    // Create a rectangle (bar)
    const rect = document.createElementNS(svgNS, "rect");
    rect.setAttribute("x", 0);
    rect.setAttribute("y", currentY);
    rect.setAttribute("width", barWidth);
    rect.setAttribute("height", barHeight);
    rect.setAttribute("fill", blendColors(percentage));

    // Append the rectangle to the SVG element
    svg.appendChild(rect);

    // Update current X position for the next bar
    currentY += barHeight;
  });

  // Convert the SVG element to a string and return
  const serializer = new XMLSerializer();
  return serializer.serializeToString(svg);
}

export function formatFileSize(size) {
  if (size > (1024 * 1024))
    return (size / (1024 * 1024)).toFixed(2) + " MB";
  return (size / (1024.0)).toFixed(0) + " KB";
}

export function formatPercent(percent) {
  if (!percent)
    return "0";
  if (percent < 1.0)
    return percent.toPrecision(2);
  return percent.toPrecision(3);
}

export function clickDownloadLink(url, target = "") {
  var link = document.createElement("a");
  link.style.display = 'none';
  link.href = url;
  if (target != "") {
    link.target = "blank";
  }
  link.click();
  link.remove();
}

export function resolveNotificationMessage(messageCode, messageStrings) {
  if (!messageCode) {
    return messageStrings["someThingWentWrong"];
  }
  const keys = Object.keys(messageStrings).filter(item => {
    if (messageCode.indexOf(item) >= 0) {
      return item;
    }
  });
  return (keys && keys[0] && messageStrings[keys[0]]) || messageCode;
}


//https://www.cluemediator.com/how-to-implement-recaptcha-v3-in-react
export function loadScriptByURL(id, url, callback) {
  const isScriptExist = document.getElementById(id);

  if (!isScriptExist) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    script.id = id;
    script.onload = function () {
      if (callback) callback();
    };
    document.body.appendChild(script);
  }
  if (isScriptExist && callback) callback();
}

export function toggleCaptcha(loggedIn) {
  if (loggedIn) {
    hideCaptcha();
  } else {
    showCaptcha();
  }
}

export function showCaptcha() {
  loadScriptByURL("google-recaptcha", config.captchaUrl);
}

export function hideCaptcha() {
  var captchaScript = document.getElementById("google-recaptcha");
  if (captchaScript) {
    captchaScript.remove();
    const captchas = document.getElementsByClassName("grecaptcha-badge");
    if (captchas.length > 0) {
      captchas[0].remove();
    }
  }
}

export function createUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function createEvenlySpacedArray(min, max, numElements) {
  if (numElements < 2) {
      throw new Error('Number of elements must be at least 2.');
  }

  const step = (max - min) / (numElements - 1);
  const result = [];

  for (let i = 0; i < numElements; i++) {
      result.push(min + i * step);
  }

  return result;
}


// inspired by https://www.npmjs.com/package/get-browser-fingerprint
export const getBrowserFingerprint = ({
  hardwareOnly = false,
  enableWebgl = true,
  enableScreen = true,
  debug = false,
} = {}) => {
  const {
    cookieEnabled,
    deviceMemory,
    doNotTrack,
    hardwareConcurrency,
    language,
    languages,
    maxTouchPoints,
    platform,
    userAgent,
    vendor,
  } = window.navigator;

  const { width, height, colorDepth, pixelDepth } = enableScreen ? window.screen : {}; // undefined will remove this from the stringify down here
  const timezoneOffset = new Date().getTimezoneOffset();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const touchSupport = 'ontouchstart' in window;
  const devicePixelRatio = window.devicePixelRatio;

  const canvas = getCanvasID(debug);
  const webgl = enableWebgl ? getWebglID(debug) : undefined; // undefined will remove this from the stringify down here
  const webglInfo = enableWebgl ? getWebglInfo(debug) : undefined; // undefined will remove this from the stringify down here

  const data = hardwareOnly
    ? JSON.stringify({
      canvas,
      colorDepth,
      deviceMemory,
      devicePixelRatio,
      hardwareConcurrency,
      height,
      maxTouchPoints,
      pixelDepth,
      platform,
      touchSupport,
      webgl,
      webglInfo,
      width,
    })
    : JSON.stringify({
      canvas,
      colorDepth,
      cookieEnabled,
      deviceMemory,
      devicePixelRatio,
      doNotTrack,
      hardwareConcurrency,
      height,
      language,
      //languages,  // different for normal and incognito mode in Chrome
      maxTouchPoints,
      pixelDepth,
      platform,
      timezone,
      timezoneOffset,
      touchSupport,
      userAgent,
      vendor,
      webgl,
      webglInfo,
      width,
    });

  const datastring = JSON.stringify(data, null, 4);

  if (debug) console.log('fingerprint data', datastring);

  const result = murmurhash3_32_gc(datastring);
  return result;
};

export const getCanvasID = (debug) => {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const text = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ`~1!2@3#4$5%6^7&8*9(0)-_=+[{]}|;:',<.>/?";
    ctx.textBaseline = 'top';
    ctx.font = "14px 'Arial'";
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText(text, 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText(text, 4, 17);

    const result = canvas.toDataURL();

    if (debug) {
      document.body.appendChild(canvas);
    } else {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    return murmurhash3_32_gc(result);
  } catch {
    return null;
  }
};

export const getWebglID = (debug) => {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('webgl');
    canvas.width = 256;
    canvas.height = 128;

    const f =
      'attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}';
    const g =
      'precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}';
    const h = ctx.createBuffer();
    h.itemSize = 3;
    h.numItems = 3;

    ctx.bindBuffer(ctx.ARRAY_BUFFER, h);

    const i = new Float32Array([-0.2, -0.9, 0, 0.4, -0.26, 0, 0, 0.7321, 0]);

    ctx.bufferData(ctx.ARRAY_BUFFER, i, ctx.STATIC_DRAW);

    const j = ctx.createProgram();
    const k = ctx.createShader(ctx.VERTEX_SHADER);

    ctx.shaderSource(k, f);
    ctx.compileShader(k);

    const l = ctx.createShader(ctx.FRAGMENT_SHADER);

    ctx.shaderSource(l, g);
    ctx.compileShader(l);
    ctx.attachShader(j, k);
    ctx.attachShader(j, l);
    ctx.linkProgram(j);
    ctx.useProgram(j);

    j.vertexPosAttrib = ctx.getAttribLocation(j, 'attrVertex');
    j.offsetUniform = ctx.getUniformLocation(j, 'uniformOffset');

    ctx.enableVertexAttribArray(j.vertexPosArray);
    ctx.vertexAttribPointer(j.vertexPosAttrib, h.itemSize, ctx.FLOAT, !1, 0, 0);
    ctx.uniform2f(j.offsetUniform, 1, 1);
    ctx.drawArrays(ctx.TRIANGLE_STRIP, 0, h.numItems);

    const n = new Uint8Array(canvas.width * canvas.height * 4);
    ctx.readPixels(0, 0, canvas.width, canvas.height, ctx.RGBA, ctx.UNSIGNED_BYTE, n);

    const result = JSON.stringify(n).replace(/,?"[0-9]+":/g, '');

    if (debug) {
      document.body.appendChild(canvas);
    } else {
      ctx.clear(ctx.COLOR_BUFFER_BIT | ctx.DEPTH_BUFFER_BIT | ctx.STENCIL_BUFFER_BIT);
    }

    return murmurhash3_32_gc(result);
  } catch {
    return null;
  }
};

export const getWebglInfo = () => {
  try {
    const ctx = document.createElement('canvas').getContext('webgl');

    const result = {
      VERSION: String(ctx.getParameter(ctx.VERSION)),
      SHADING_LANGUAGE_VERSION: String(ctx.getParameter(ctx.SHADING_LANGUAGE_VERSION)),
      VENDOR: String(ctx.getParameter(ctx.VENDOR)),
      SUPORTED_EXTENSIONS: String(ctx.getSupportedExtensions()),
    };

    return result;
  } catch {
    return null;
  }
};

export const murmurhash3_32_gc = (key) => {
  const remainder = key.length & 3; // key.length % 4
  const bytes = key.length - remainder;
  const c1 = 0xcc9e2d51;
  const c2 = 0x1b873593;

  let h1, h1b, k1;

  for (let i = 0; i < bytes; i++) {
    k1 =
      (key.charCodeAt(i) & 0xff) |
      ((key.charCodeAt(++i) & 0xff) << 8) |
      ((key.charCodeAt(++i) & 0xff) << 16) |
      ((key.charCodeAt(++i) & 0xff) << 24);
    ++i;

    k1 = ((k1 & 0xffff) * c1 + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
    k1 = (k1 << 15) | (k1 >>> 17);
    k1 = ((k1 & 0xffff) * c2 + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;

    h1 ^= k1;
    h1 = (h1 << 13) | (h1 >>> 19);
    h1b = ((h1 & 0xffff) * 5 + ((((h1 >>> 16) * 5) & 0xffff) << 16)) & 0xffffffff;
    h1 = (h1b & 0xffff) + 0x6b64 + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16);
  }

  const i = bytes - 1;

  k1 = 0;

  switch (remainder) {
    case 3: {
      k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
      break;
    }
    case 2: {
      k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
      break;
    }
    case 1: {
      k1 ^= key.charCodeAt(i) & 0xff;
      break;
    }
  }

  k1 = ((k1 & 0xffff) * c1 + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
  k1 = (k1 << 15) | (k1 >>> 17);
  k1 = ((k1 & 0xffff) * c2 + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
  h1 ^= k1;

  h1 ^= key.length;

  h1 ^= h1 >>> 16;
  h1 = ((h1 & 0xffff) * 0x85ebca6b + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
  h1 ^= h1 >>> 13;
  h1 = ((h1 & 0xffff) * 0xc2b2ae35 + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16)) & 0xffffffff;
  h1 ^= h1 >>> 16;

  return h1 >>> 0;
};

if (typeof window !== 'undefined') {
  window.getBrowserFingerprint = getBrowserFingerprint;
}



